
import { Component, Prop, Vue } from "vue-property-decorator";
import IconBadge from "@/components/V2/IconBadge/iconBadge.vue";

const CLASS = "service-counter";
@Component({
  components: {
    IconBadge,
  },
})
export default class ServiceCounter extends Vue {
  @Prop({ type: String, default: null }) readonly label: string;
  @Prop({ type: Number, default: 0 }) readonly value: string;
  @Prop({ type: String, default: null }) readonly icon: string;
  @Prop({ type: String, default: null }) readonly buttonLabel: string;
  @Prop({ type: Function }) readonly action;
  @Prop({ type: Boolean, default: false }) readonly disabled: boolean;
  @Prop({ type: Boolean, default: true }) readonly divider: boolean;

  get classes() {
    return {
      [`${CLASS}_divider`]: this.divider,
    };
  }

  emitEvent() {
    this.action?.();
  }
}
